import { RoleResponse } from '../../../../web-api-client';
import { UserRole } from '../../models';

export const mapUserRoleFromResponse = (response: RoleResponse): UserRole => ({
  id: response.id!,
  name: response.name!,
});
